import { createContext } from "react";
export const userProviderContext=createContext(localStorage.getItem('provider'));